<template>
  <div>

    <page-heading-info
    title="Jefferson County Law Library"
    phone="(740) 283-8553"
    courthouse="true"
    hours="8:30 - 4:30 (M-F)"
    lunch="closed 12:00-1:00"
    floor="3rd Floor"
    pobox=""
    ></page-heading-info>

    <!-- General Info ############################ -->
    <div class="row">
      <div class="col-md-6 mt-3">
        <p>
          The Jefferson County Law Library is located on the third floor of the county courthouse.
          The Law Library serves the legal community of Jefferson County and its surrounding areas. This includes judges, attorneys, county officials
          and their departments and agencies.
        </p>

        <p>
          The Law Library also welcomes the general public to visit the library and use its services.
          <div class="text-primary text-bold">
            Non-members of the Law Library are advised to call (740) 283-8553 beforehand to schedule an appointment during our public hours.
          </div>

          <div class="row">
            <div class="col bg-grey-01 m-3">
              <div class="text-bold text-underline mt-3">
                Public Hours
              </div>

              <div class="mt-2">
                Tuesday:  1:00pm to 4:00pm 
              </div>

              <div class="mt-2 mb-4">
                Thursday &amp; Friday: 9:00am to 12:00pm
              </div>
            </div>
          </div> 
        </p>

        <p>
          The Jefferson County Law Library is staffed by one Law Librarian and is governed by the Jefferson County Law Library Resources Board.
          The Library is a member of the Ohio Regional Association of Law Libraries.
        </p>
      </div>

      <div class="col-md-6 mt-3 image-flex">
        <img src="/static/images/general/law_library_03.jpg" alt="Viewing the library bookcases and workstations." class="" />
      </div>
    </div>

    <!-- monthly meetings info ################## -->
    <text-box-title
    title="Law Library Resources Board Meeting Schedule"
    default="false"
    align="left"
    list-dots="false"
    class="mt-3"
    id="library-meetings">

    <div class="col-md-6 mt-3">
      <div class="row">
        <div class="col">
          <icon-title
          title="Meeting Schedule"
          icon="event_available"
          underline="true"
          ></icon-title>
        </div>
      </div>

      <div>
        <p class="row">
        The quarterly meetings of the Jefferson County Law Library Resources Board are scheduled for the 2nd Thursday of March, June, September and December.
        </p>

        <p class="row">
        These meeting dates are subject to change, so it is best to check this website for updates or contact the Law Library at (740) 283-8553.
        </p>
      </div>

    </div>

    <div class="col-md-6 mt-3">
      <div class="row">
        <div class="col">
          <icon-title
          title="Meeting Location"
          icon="place"
          underline="true"
          ></icon-title>
        </div>
      </div>

      <p>
        Meetings take place at 2:30 p.m. in the Law Library on the third floor of the Jefferson County Courthouse.
      </p>
      <p>
        Instructions to attend remote will be provided upon request, email: law_library@jeffcch.com
      </p>

      <div class="text-light bg-secondary p-3 mt-3 text-bold p-clear">
        <note-text note-id="20"></note-text>
      </div>

    </div>
    </text-box-title>

    <text-box-title
    title="Law Library News"
    default="false"
    align="left"
    list-dots="false"
    class="mt-3"
    id="library-news">
      <div class="col mt-3">
        <note-text note-id="48"></note-text>
      </div>
    </text-box-title>

    <!-- Services ############################ -->
    <text-box-title
    title="Library Services"
    default="false"
    align="left"
    list-dots="false"
    class="center-the-things mt-3"
    id="library-services"
    >

    <div class="col-md-6 mt-3">
      <div class="row">
        <div class="col">
          <icon-title
          title="Library Features"
          icon="book"
          underline="true"
          ></icon-title>
        </div>
      </div>

      <div class="row pl-3">
        <ul class="no-dots">
          <li>
            Large selection of printed literature
          </li>
          <li>
            Inter-Library Loan Service
          </li>
          <li>
            Copying - $.10/page B&amp;W or $.50/page Color
          </li>
          <li>
            Faxing - $1.00/page
          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-6 mt-3">
      <div class="row  ">
        <div class="col">
          <icon-title
          title="Legal Research Databases"
          icon="computer"
          underline="true"
          ></icon-title>
        </div>
      </div>

      <div class="row pl-3">
        <note-text note-id="58"></note-text>
      </div>
    </div>

    </text-box-title>

    <!-- New Printed Material ######################### -->
    <text-box-title title="New Printed Material" class="mt-3">

      <div class="col-md-6 mt-3 no-dots">
          <icon-title
          title="LexisNexis"
          icon="content_paste"
          underline="true"
          ></icon-title>
        <note-text note-id="21" class="clear-list"></note-text>
      </div>

      <div class="col-md-6 mt-3 no-dots">
          <icon-title
          title="West Publishing"
          icon="content_paste"
          underline="true"
          ></icon-title>
        <note-text note-id="22" class="clear-list"></note-text>
      </div>

      <div class="col-md-6 mt-3 no-dots">
          <icon-title
          title="Ohio State Bar Association Continuing Legal Education Seminar Books"
          icon="content_paste"
          underline="true"
          ></icon-title>
        <note-text note-id="23" class="clear-list"></note-text>
      </div>

      <div class="col-md-6 mt-3 no-dots">
        <br />
          <icon-title
          title="Library Catalog"
          icon="content_paste"
          underline="true"
          ></icon-title>
        <a href="https://opac.libraryworld.com/opac/signin.php?libraryname=JEFFERSON%20COUNTY">
          Search Catalog
        </a>
      </div>

    </text-box-title>

    <!-- Library Personnel ############################ -->
    <text-box-title
    title="Library Personnel"
    default="false"
    align="left"
    list-dots="false"
    class="center-the-things mt-3">

    <div class="col-md-6 mt-3">
      <div class="row">
        <div class="col">
          <icon-title
          title="Law Librarian"
          icon="book"
          underline="true"

          ></icon-title>
        </div>
      </div>

      <div class="row">
        <div class="col">
        Jeanmarie Byrge<br />
        <strong>law_library@jeffcch.com</strong>
        </div>
      </div>
    </div>

    <div class="col-md-6 mt-3">
      <div class="row">
        <div class="col">
          <icon-title
          title="Board of Trustees"
          icon="people"
          underline="true"

          ></icon-title>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <ul class="no-dots">
            <li>
              The Honorable John J. Mascio, Chairman
            </li>
            <li>
              Attorney Bernard C. Battistel
            </li>
            <li>
              Attorney Mary F. Corabi
            </li>
            <li>
              Attorney Cerryn C. Marshall
            </li>
            <li>
              Attorney Eric M. Reszke
            </li>
          </ul>
        </div>
      </div>
    </div>
    </text-box-title>

    <!-- Services ############################ -->
    <text-box-title
    title="Law Library Legal Links"
    default="false"
    align="left"
    list-dots="false"
    class="mt-3"
    id="legal-links">

    <div class="col">

      <div class="row mt-3">
        <div class="col-md-6">
          <div class="row">
            <div class="col">
              <icon-title
              title="Legal Resource Databases"
              icon="content_paste"
              underline="true"
              ></icon-title>
            </div>
          </div>

          <div class="row pl-3">
            <ul class="no-dots">
              <li>
                <a href="http://www.cocll.ohio.gov/">Statewide Consortium of Ohio County Law Library Resources Board</a>
              </li>
              <li>
                <a href="http://www.findlaw.com/">FindLaw</a>
              </li>
              <li>
                <a href="http://www.martindale.com/">Martindale</a>
              </li>
              <li>
                <a href="https://www.ohiolegalhelp.org">Ohio Legal Help</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row">
            <div class="col">
              <icon-title
              title="Codes, Statutes, &amp; Ordinances"
              icon="content_paste"
              underline="true"
              ></icon-title>
            </div>
          </div>

          <div class="row pl-3">
            <ul class="no-dots">
              <!-- <li>
                <a href="http://www.amlegal.com/codes/client/steubenville_oh/">Codified Ordinances of Steubenville</a>
              </li> -->
              <li>
                <a href="http://codes.ohio.gov/orc">Ohio Revised Code</a>
              </li>
              <li>
                <a href="http://codes.ohio.gov/oac">Ohio Administrative Code</a>
              </li>
              <li>
                <a href="https://www.sos.state.oh.us/legislation-and-ballot-issues/laws-of-ohio/">Laws of Ohio</a>
              </li>
              <li>
                <a href="http://uscode.house.gov/">United States Code</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-md-6">
          <div class="row">
            <div class="col">
              <icon-title
              title="Local Government"
              icon="content_paste"
              underline="true"
              ></icon-title>
            </div>
          </div>

          <div class="row pl-3">
            <ul class="no-dots">
              <li>
                <a href="https://www.jeffersoncountyohcoc.com/forms">Jefferson County Clerk of Courts Forms</a>
              </li>
              <li>
                <a href="http://www.cityofsteubenville.us/">City of Steubenville</a>
              </li>
              <li>
                <a href="https://codelibrary.amlegal.com/codes/steubenville/latest/steubenville_oh/0-0-0-28">Codified Ordinances of the City of Steubenville</a>
              </li> 
              <li>
                <a href="http://www.seventh.courts.state.oh.us/">Seventh District Court of Appeals</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row">
            <div class="col">
              <icon-title
              title="Ohio Government &amp; Legislation"
              icon="content_paste"
              underline="true"
              ></icon-title>
            </div>
          </div>

          <div class="row pl-3">
            <ul class="no-dots">
              <li>
                <a href="https://governor.ohio.gov/">Ohio Governor</a>
              </li>
              <li>
                <a href="https://www.sos.state.oh.us/">Ohio Secretary of State</a>
              </li>
              <!-- <li>
                <a href="https://www.legislature.state.oh.us/">Ohio General Assembly</a>
              </li> -->
              <li>
                <a href="https://ohioauditor.gov/">Ohio Auditor of State</a>
              </li>
              <li>
                <a href="https://www.supremecourt.ohio.gov/">Ohio Supreme Court</a>
                |
                <a href="https://www.supremecourt.ohio.gov/courts/services-to-courts/court-services/access-to-justice-resources/">Access to Justice</a>
              </li>
	      <li>
                <a href="https://www.supremecourt.ohio.gov/laws-rules/ohio-rules-of-court/">Ohio Rules of Court</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

    </div>

    </text-box-title>

    <!--<text-box-title title="Jefferson County Rules of Court">
      <note-documents note-id="26" class="ml-3 mr-3 mt-3"></note-documents>
    </text-box-title>-->

    <text-box-title
    title="The History of the Law Library"
    default="false"
    align="left"
    list-dots="false"
    class="mt-3"
    id="library-history">

    <div class="col">
      <library-history>
      </library-history>
    </div>

    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'
import TextBox from '@/components/layout/TextBox.vue'
import NoteText from '@/components/display-utils/NoteText.vue'
import NoteDocuments from '@/components/display-utils/NoteDocuments.vue'
import IconTitle from '@/components/display-utils/IconTitle.vue'
import LibraryHistory from '@/views/library/LibraryHistory.vue'

export default {
  components: {
    PageHeadingInfo,
    TextBoxTitle,
    TextBox,
    NoteText,
    NoteDocuments,
    IconTitle,
    LibraryHistory
  },
  data () {
    return {}
  }
}
</script>

<style>

.linker {
  cursor: pointer;
}

</style>
